<template>
  <div class="domains">
    <div class="domains__header">
      <h2>Domains <span>2 / 2</span></h2>
      <el-button type="primary" icon="el-icon-plus">Domain</el-button>
    </div>
    <ul class="domains__list">
      <li class="domains__list--item" v-bind:key="domain.index" v-for="domain in domains">
        <domain-item :domain="domain"></domain-item>
      </li>
    </ul>
  </div>
</template>
<script>
import DomainItem from './DomainItem';

export default {
  name: 'Domains',
  data: () => ({
    domains: [
      {
        index: 0,
        name: 'kwapis.net',
        path: 'webspace/htdocs/wp',
        active: true,
        activated: '19.01.2008',
        subdomains: [
          {
            index: 0,
            name: 'Subdomain1',
            path: 'external',
            valid: true,
            comment: '',
          },
          {
            index: 1,
            name: 'Subdomain2',
            path: 'Webspace/htdocs/wp-admin',
            valid: false,
            comment: 'Incorrect target',
          },
        ],
      },
      {
        index: 1,
        name: 'P123213123.horst.site',
        path: 'webspace/htdocs/',
        active: false,
        activated: '19.01.2008',
        subdomains: [],
      },
    ],
  }),
  components: {
    'domain-item': DomainItem,
  },
};
</script>
<style lang="scss">
.domains {
  position: absolute;
  top: 70px;
  right: 0;
  padding: 0 50px;
  width: calc(100% - 100px);

  &__header {
    width: 100%;
    margin: 10px 0 30px 0;
    border-bottom: 1px solid #aaaaaa;
    display: flex;
    justify-content: space-between;
    align-items: center;

      h2 {
        text-align: left;
        font-size: 24px;

        span {
          font-size: 16px;
          font-weight: 300;
        }
      }
  }

  &__list {
    list-style: none;
    padding: 0;

    &--item {
      position: relative;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Domains.vue